export default __webpack_public_path__ + "static/P2P_Cam_Live_02-a6da6850fce826a5cff8553450a255bf.webp";